import React from 'react';

import { Link } from 'react-router-dom';

import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Menu, X } from 'lucide-react';
import useCurrentUser from './useCurrentUser';

import Toast from './Toast';
import Store from './Store';

const drawerWidth = 240;

export default function NavBar({ drawerToggle }) {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  let logout = () => {
    setMobileMenuOpen(false);
    return Store.logout();
  };

  const [currentUser] = useCurrentUser();

  return (
    <div>
      <nav className="bg-primary text-primary-foreground shadow-md z-50 relative">
        <div className="flex items-center justify-between px-4 h-14">
          {drawerToggle && (
            <Button
              variant="ghost"
              size="icon"
              aria-label="open drawer"
              onClick={drawerToggle}
              className="md:hidden -ml-3 text-white hover:bg-white/10"
            >
              <Menu className="h-5 w-5" />
            </Button>
          )}
          <Link
            to="/"
            className="flex-1 text-white no-underline text-lg font-semibold"
          >
            Pushback
          </Link>
          <div className="hidden md:flex items-center gap-2">
            {currentUser?.uid ? (
              <>
                <Button
                  variant="ghost"
                  asChild
                  className="text-white hover:bg-white/10"
                >
                  <Link to="/profile">Profile</Link>
                </Button>
                <Button
                  variant="ghost"
                  asChild
                  className="text-white hover:bg-white/10"
                >
                  <a
                    href="https://pushback.io/docs/getting-started/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Docs
                  </a>
                </Button>
                <Button
                  variant="ghost"
                  onClick={logout}
                  className="text-white hover:bg-white/10"
                >
                  Logout
                </Button>
              </>
            ) : (
              <Button
                variant="ghost"
                asChild
                className="text-white hover:bg-white/10"
              >
                <Link to="/login">Login</Link>
              </Button>
            )}
          </div>
          <div className="md:hidden">
            <DropdownMenu
              open={mobileMenuOpen}
              onOpenChange={setMobileMenuOpen}
            >
              <DropdownMenuTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="text-white hover:bg-white/10 md:hidden"
                >
                  <Menu className="h-5 w-5" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="md:hidden">
                {currentUser?.uid ? (
                  <>
                    <DropdownMenuItem asChild>
                      <Link
                        to="/profile"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Profile
                      </Link>
                    </DropdownMenuItem>
                    <DropdownMenuItem asChild>
                      <a
                        href="https://pushback.io/docs/getting-started/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        Docs
                      </a>
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={logout}>Logout</DropdownMenuItem>
                  </>
                ) : (
                  <DropdownMenuItem asChild>
                    <Link to="/login" onClick={() => setMobileMenuOpen(false)}>
                      Login
                    </Link>
                  </DropdownMenuItem>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
        {Store.data.successMsg != null ? (
          <Toast
            color="green"
            message={Store.data.successMsg}
            drawerWidth={drawerWidth}
          />
        ) : null}
        {Store.data.error != null ? (
          <Toast
            color="red"
            message={`Error: ${Store.data.error}`}
            drawerWidth={drawerWidth}
          />
        ) : null}
      </nav>
    </div>
  );
}
